import React, { Component, Fragment } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import { IconButton, Tooltip } from "@material-ui/core";
import { Visibility as ViewIcon, Edit as EditIcon } from "@material-ui/icons";
import {
  withModulesManager,
  withHistory,
  formatMessage,
  formatMessageWithValues,
  formatDateFromISO,
  Searcher,
} from "@openimis/fe-core";
import { fetchPolicyholderEnrollments } from "../actions";
import EnrollmentFilter from "./EnrollmentFilter";
import EnrollmentStatusBadge from "./common/EnrollmentStatusBadge";
import {
  DEFAULT_ENROLLMENT_FILTERS,
  DEFAULT_PAGE_SIZE,
  ROWS_PER_PAGE_OPTIONS,
} from "../constants";
import { filtersToQueryParams, enrollmentRowIdentifier } from "../utils/searcher";
import {
  normalizePolicyholderData,
  formatDisplayValue,
} from "../utils/enrollmentData";

class PolicyHolderEnrollmentSearcher extends Component {
  constructor(props) {
    super(props);
    this.rowsPerPageOptions = props.modulesManager.getConf(
      "fe-enrollment",
      "policyHolderEnrollmentFilter.rowsPerPageOptions",
      ROWS_PER_PAGE_OPTIONS
    );
    this.defaultPageSize = props.modulesManager.getConf(
      "fe-enrollment",
      "policyHolderEnrollmentFilter.defaultPageSize",
      DEFAULT_PAGE_SIZE
    );
  }

  fetch = (prms) => {
    this.props.fetchPolicyholderEnrollments(this.props.modulesManager, prms);
  };

  openEdit = (e) => {
    if (this.props.history) {
      this.props.history.push(`/enrollment/policyholder/${e.uuid}/edit`);
    }
  };

  headers = () => [
    "policyHolderEnrollment.company",
    "policyHolderEnrollment.code",
    "policyHolderEnrollment.contact",
    "policyHolderEnrollment.status",
    "policyHolderEnrollment.enrollmentDate",
    "",
  ];

  sorts = () => [null, null, null, ["status", true], ["dateCreated", false], null];

  itemFormatters = () => {
    const { modulesManager, intl, onDoubleClick } = this.props;
    return [
      (e) => {
        const ph = normalizePolicyholderData(e.policyholderData);
        return formatDisplayValue(ph.name || ph.tradeName);
      },
      (e) => formatDisplayValue(normalizePolicyholderData(e.policyholderData).code),
      (e) => {
        const ph = normalizePolicyholderData(e.policyholderData);
        return formatDisplayValue(ph.phone) || formatDisplayValue(ph.email);
      },
      (e) => <EnrollmentStatusBadge status={e.status || "DRAFT"} size="small" />,
      (e) => formatDateFromISO(modulesManager, intl, e.dateCreated) || "-",
      (e) => (
        <>
          <Tooltip title={formatMessage(intl, "enrollment", "general.view") || "View"}>
            <IconButton
              size="small"
              onClick={(ev) => {
                ev.stopPropagation();
                onDoubleClick && onDoubleClick(e);
              }}
            >
              <ViewIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          {e.status === "DRAFT" && (
            <Tooltip title={formatMessage(intl, "enrollment", "general.edit") || "Edit"}>
              <IconButton
                size="small"
                onClick={(ev) => {
                  ev.stopPropagation();
                  this.openEdit(e);
                }}
              >
                <EditIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          )}
        </>
      ),
    ];
  };

  render() {
    const {
      intl,
      policyHolderEnrollments,
      policyHolderEnrollmentsPageInfo,
      fetchingPolicyHolderEnrollments,
      fetchedPolicyHolderEnrollments,
      errorPolicyHolderEnrollments,
      cacheFiltersKey,
      onDoubleClick,
    } = this.props;

    const totalCount =
      policyHolderEnrollmentsPageInfo?.totalCount ??
      policyHolderEnrollments?.length ??
      0;

    return (
      <Fragment>
        <Searcher
          module="enrollment"
          cacheFiltersKey={cacheFiltersKey}
          FilterPane={EnrollmentFilter}
          items={policyHolderEnrollments}
          itemsPageInfo={{ ...policyHolderEnrollmentsPageInfo, totalCount }}
          fetchingItems={fetchingPolicyHolderEnrollments}
          fetchedItems={fetchedPolicyHolderEnrollments}
          errorItems={errorPolicyHolderEnrollments}
          tableTitle={formatMessageWithValues(
            intl,
            "enrollment",
            "policyHolderEnrollment.searcher.results",
            { count: totalCount.toLocaleString() }
          )}
          rowsPerPageOptions={this.rowsPerPageOptions}
          defaultPageSize={this.defaultPageSize}
          defaultFilters={DEFAULT_ENROLLMENT_FILTERS}
          defaultOrderBy="-dateCreated"
          fetch={this.fetch}
          rowIdentifier={enrollmentRowIdentifier}
          filtersToQueryParams={filtersToQueryParams}
          headers={this.headers}
          itemFormatters={this.itemFormatters}
          sorts={this.sorts}
          onDoubleClick={(i) => onDoubleClick && onDoubleClick(i)}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  policyHolderEnrollments: state.enrollment?.policyHolderEnrollments || [],
  policyHolderEnrollmentsPageInfo:
    state.enrollment?.policyHolderEnrollmentsPageInfo || {},
  fetchingPolicyHolderEnrollments:
    state.enrollment?.fetchingPolicyHolderEnrollments,
  fetchedPolicyHolderEnrollments:
    state.enrollment?.fetchedPolicyHolderEnrollments,
  errorPolicyHolderEnrollments: state.enrollment?.errorPolicyHolderEnrollments,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ fetchPolicyholderEnrollments }, dispatch);

export default withModulesManager(
  withHistory(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(injectIntl(PolicyHolderEnrollmentSearcher))
  )
);
